import { render, staticRenderFns } from "./StaffSearchBarComponent.vue?vue&type=template&id=56e1cee8"
import script from "./StaffSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./StaffSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./StaffSearchBarComponent.vue?vue&type=style&index=0&id=56e1cee8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports